function createImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (err) => reject(err));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });
}

export async function getCroppedImg(
  imageSrc: string,
  crop: { x: number; y: number; width: number; height: number },
  rotation = 0,
): Promise<Blob> {
  const image = await createImage(imageSrc);

  const radians = (rotation * Math.PI) / 180;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d')!;

  const sin = Math.abs(Math.sin(radians));
  const cos = Math.abs(Math.cos(radians));
  const rotatedWidth = image.width * cos + image.height * sin;
  const rotatedHeight = image.width * sin + image.height * cos;

  canvas.width = rotatedWidth;
  canvas.height = rotatedHeight;

  ctx.translate(rotatedWidth / 2, rotatedHeight / 2);
  ctx.rotate(radians);
  ctx.drawImage(image, -image.width / 2, -image.height / 2);

  const croppedCanvas = document.createElement('canvas');
  const croppedCtx = croppedCanvas.getContext('2d')!;
  croppedCanvas.width = crop.width;
  croppedCanvas.height = crop.height;

  croppedCtx.drawImage(
    canvas,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    crop.width,
    crop.height,
  );

  const finalCanvas = document.createElement('canvas');
  const finalCtx = finalCanvas.getContext('2d')!;

  finalCanvas.width = croppedCanvas.height;
  finalCanvas.height = croppedCanvas.width;

  finalCtx.translate(finalCanvas.width / 2, finalCanvas.height / 2);
  finalCtx.rotate(Math.PI / 2);
  finalCtx.drawImage(
    croppedCanvas, -croppedCanvas.width / 2, -croppedCanvas.height / 2,
  );

  return new Promise((resolve) => {
    finalCanvas.toBlob((blob) => {
      resolve(blob!);
    }, 'image/png');
  });
}
